module.exports = __webpack_public_path__ + "img/mute.c694303a.svg";